module.exports = __webpack_public_path__ + "static/8-32d36868df7d15cace30997ccee87fde.png";